module.exports = __webpack_public_path__ + "img/card.8ff5db96.png";